(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Dashboard",
                {
                    url: "/Dashboard",
                    component: "dashboard",
                    PageTitle: "Dashboard",
                    resolve: {
                        surveyRenewals: ["eligibilityFormApi", function (eligibilityFormApi) {
                            return eligibilityFormApi.getSurveyRenewals(null).then(function (surveys) {
                                return surveys;
                            }, function () {
                                return null;
                            });
                        }]
                    }
                });
        }
    ]);

    app.component("dashboard",
        {
            templateUrl: "App/Dashboard/Dashboard.html",
            controller: dashboardController,
            bindings: {
                user: "<",
                delegates: "<",
                masterAdvisorAgreementRequiredRecord: "<",
                userMasterAdvisorAgreement: "<",
                userOnbordingRecord: "<",
                surveyRenewals: "<"
            }
        });

    dashboardController.$inject =
        ["_", "$cookies", "covid19Constant", "covid19Factory", "eligibilityFormApi", "featureToggleService", "$mdDialog", "$mdSidenav", "notificationDialog", "permissionService", "$scope", "$state", "surveyRenewalDialog", "$timeout"];

    function dashboardController(
        _, $cookies, covid19Constant, covid19Factory, eligibilityFormApi, featureToggleService, $mdDialog, $mdSidenav, notificationDialog, permissionService, $scope, $state, surveyRenewalDialog, $timeout) {
        var $ctrl = this;
        ng.extend($ctrl, {
            ui: {
                //lastAccessDate: $cookies.get("last-access-date")
                //    ? $cookies.get("last-access-date")
                //    : moment().subtract(7, "days")
            }//,
            //carrierUpdates: covid19Constant.carrierUpdates,
            //categories: covid19Constant.categories,
            //latestCovidLinks: []
        });

        $ctrl.$onInit = function () {
            //we can define specific notifications using the notificationDialog service.  For example, we can check for specific cookie and show the notification dialog with corresponding content.  New areas can be added to the notifications code in Home/Notifications folder
            /*$ctrl.notificationCookie = $cookies.get('hide-covid-notification');
            if (!$ctrl.notificationCookie) {
                notificationDialog.open('covid-19').then(function () {
                    init();
                }).catch(function (error) {
                    console.log(error);
                });
            }
            else {*/
            if (!!$ctrl.surveyRenewals && $ctrl.surveyRenewals.length > 0) {

                var openRenewals = 0;
                ng.forEach($ctrl.surveyRenewals, function (s, i) {
                    if (s.SurveyRenewalStatusId === 1) {
                        openRenewals++;
                    }
                });

                if (openRenewals > 0) {
                    surveyRenewalDialog.open(event, $ctrl.surveyRenewals, null).then(function (obj) {
                        ng.extend($ctrl, obj);
                    });
                }
            }

            var isOptedOut = permissionService.getOptOutMasterAdvisorAgreement() === null ? false : true;
            var isSigningRequired = $ctrl.masterAdvisorAgreementRequiredRecord !== null ? true : false;
            var isAlreadySigned = $ctrl.userMasterAdvisorAgreement === null ? false : true;
            var isOnboardingWizardRequired = ($ctrl.userOnbordingRecord !== null && $ctrl.userOnbordingRecord.InfoValidated === null) ? true : false;

            if (permissionService.getOnBehalfOfUserId() === null) {
                if (isOnboardingWizardRequired) {
                    if (isSigningRequired) {
                        if (isAlreadySigned) {
                            $state.go("Home.ROR.Steps");
                        } else {
                            $state.go("Home.ROR.Intro");
                        }
                    } else {
                        $state.go("Home.ROR.Steps");
                    }
                } else {
                    if (isSigningRequired) {
                        if (!isAlreadySigned && !isOptedOut
                        ) {
                            $state.go("Home.ROR.Agreement");
                        } else $ctrl.checkRestrictedDashboardWorkflow();
                    } else $ctrl.checkRestrictedDashboardWorkflow();
                }

                if ($ctrl.delegates.length) {
                    $timeout(function () {
                        $mdSidenav("user-info-expand").toggle();
                    },
                        1000);
                }
            } else $ctrl.checkRestrictedDashboardWorkflow();

            //$ctrl.latestCovidLinks = $ctrl.latestCovidLinks.concat(covid19Factory.getLatestAssets($ctrl.ui.lastAccessDate, $ctrl.categories).links);
            //$ctrl.latestCovidLinks = $ctrl.latestCovidLinks.concat(covid19Factory.getLatestAssets($ctrl.ui.lastAccessDate, $ctrl.carrierUpdates).links);
            //latestLinks = latestLinks.concat($ctrl.carrierRecentUpdates.links);
            //console.log($ctrl.latestCovidLinks);

            $ctrl.lastDate = covid19Factory.getLatestDate();
            //}
        };

        $ctrl.checkRestrictedDashboardWorkflow = function () {
            if (!permissionService.hasOnePermission("MenuResources:View")) {
                //$state.go("Home.Tools.SureLc");
                $state.go("Home.ROR.Contract");
            }
        };

        $ctrl.DashboardTiles = [
            {
                ID: "figSymposiumTile",
                SREF: "Home.Resources.FIGSymposium",
                Title: "FIGSymposium",
                LogoIMG: "fig-symposium-2021.png",
                SubTitle: "",
                Description: "The FIG Symposium is committed to presenting you with the opportunities to learn and to grow both personally and professionally.",
                Active: true,
                ShowIfAll: "FigSymposium:View"
            },
            {
                ID: "covidTile",
                SREF: "Home.Resources.Covid19",
                Title: "Digital Marketing Assets",
                LogoIMG: "Digital-Marketing-Assets-Logo.png",
                SubTitle: "How to Manage Your Business Digitally",
                Description: "FIG's digital resource center is here to help you navigate your business in a digital world.",
                Active: true,
                ShowIfAll: "MenuResources:View"
            },
            {
                ID: "MedicarePlanningTile",
                SREF: "Home.Resources.MedicarePlanning",
                Title: "MedicarePlanning",
                LogoIMG: "Medicare-Planning-Desk-Logo.png",
                SubTitle: "",
                Description: "Begin including Medicare insurance planning with your clients via our exclusive alliance with MedicareCompareUSA.",
                Active: true,
                ShowIfAll: "MedicarePlanning:View"
            },
            {
                ID: "greeceTile",
                SREF: "Home.Resources.Greece",
                Title: "Greece",
                LogoIMG: "greece-logo-sm.png",
                SubTitle: "Athens, Greece",
                Description: "Discover the wonders of ancient civilization. Explore a pristine coastline with hidden coves and golden beaches.",
                Active: false,
                ShowIfAll: "Greece:View"
            },
            {
                ID: "irelandTile",
                SREF: "Home.Resources.Ireland",
                Title: "Ireland",
                LogoIMG: "dublin-logo-sm.png",
                SubTitle: " ",
                Description: "Join FIG’s exclusive escape to Dublin, Ireland!",
                Active: true,
                ShowIfAll: "Ireland:View"
            },
            {
                ID: "elevateTile",
                SREF: "Home.Tools.MarketPlace.Elevate",
                Title: "Elevate",
                LogoIMG: "elevate-logo.svg",
                SubTitle: "Elevate",
                Description: "Elevate offers you exclusive, in-depth training with to the most highly respected experts in the business.",
                Active: true,
                ShowIfAll: "Elevate:View",
                HideIfOne: "Elevate:Access|ElevateEnhanced:Access"
            },
            {
                ID: "creativeTile",
                SREF: "Home.Tools.MarketPlace.CreativeServices",
                Title: "Creative Services",
                LogoIMG: "creative-services-logo.png",
                SubTitle: "Creative Services",
                Description: "All Points Media also offers simple solutions and affordable services to streamline your business and keep the momentum going.",
                Active: true,
                ShowIfAll: "CreativeServices:View",
                HideIfOne: "CreativeServices:Access|Elevate:Access|ElevateEnhanced:Access"
            },
            {
                ID: "elevateLifeTile",
                LogoIMG: "e4l-logo.svg",
                SREF: "Home.Tools.MarketPlace.ElevateLife",
                Title: "Elevate For Life",
                SubTitle: "Elevate For Life",
                Description: "Specialized Marketing Strategies",
                Active: false,
                ShowIfAll: "ElevateForLife:View",
                HideIfOne: "ElevateForLife:Access"
            },
            {
                ID: "ForceCRM",
                SREF: "Home.Resources.ForceCRM",
                Title: "ForceCRM",
                LogoIMG: "force-crm-logo.svg",
                SubTitle: "ForceCRM",
                Description: "Force CRM is more than your typical CRM. Designed to connect all aspects of your business with minimal effort from the advisor.",
                Active: true,
                ShowIfAll: "ForceCRM:View"
            },
            {
                ID: "iComply",
                SREF: "Home.Resources.iComply",
                Title: "iComply",
                LogoIMG: "icomply-logo.svg",
                SubTitle: "iComply",
                Description: "iComply is a powerful online tool for compliance suitability and fiduciary responsibilities, electronic application, and document management.",
                Active: true,
                ShowIfAll: "IComply:View"
            },
            {
                ID: "ActiveDailyLiving",
                SREF: "Home.Resources.ActiveDailyLiving",
                Title: "Active Daily Living",
                LogoIMG: "ADL-logo.svg",
                SubTitle: "Active Daily Living",
                Description: "Personalized Care Planning tools and content offered through Active Daily Living ",
                Active: true,
                ShowIfAll: "ActiveDailyLiving:View"
            },
            {
                ID: "RetireUp",
                SREF: "Home.Resources.RetireUp",
                Title: "RetireUp",
                LogoIMG: "retire-up-pro-logo.svg",
                SubTitle: "RetireUp",
                Description: "Empower your advisors to guide their clients through a personalized retirement planning experience.",
                Active: true,
                ShowIfAll: "RetireUp:View"
            },
            {
                ID: "surgeTile",
                SREF: "Home.Resources.Surge",
                Title: "Surge",
                LogoIMG: "surge-logo.svg",
                SubTitle: "Reach those business goals",
                Description: "Streamline processes and get your business on a track to continued profitability.",
                Active: true,
                ShowIfAll: "Surge:View"
            },
            {
                ID: "AdvanceYourReach",
                SREF: "Home.Resources.AdvanceYourReach",
                Title: "Advance Your Reach",
                LogoIMG: "advance-your-reach-logo_dark.png",
                SubTitle: "",
                Description: "A communication and speech resource that helps individuals portray their unique story through the use of 1 High-Converting Signature Talk.",
                Active: true,
                ShowIfAll: "MenuResources:View"
            },
            {
                ID: "truelytics",
                SREF: "Home.Resources.Truelytics",
                Title: "Truelytics",
                LogoIMG: "truelytics-logo-white-2019.png",
                SubTitle: "",
                Description: "With the support from Truelytics, we can help you transform how you discover business opportunities.",
                Active: true,
                ShowIfAll: "Truelytics:View"
            },
            {
                ID: "nextTile",
                SREF: "Home.Resources.Next",
                Title: "Next",
                LogoIMG: "next-logo.svg",
                SubTitle: "Are you ready to take the next step?",
                Description: "Let us guide you through the process to securing your succession planning strategy.",
                Active: true,
                ShowIfAll: "Next:View"
            },
            {
                ID: "totTile",
                SREF: "Home.Resources.TOT",
                Title: "Tip of the Triangle",
                LogoIMG: "TOT-logo-sm.png",
                SubTitle: "Tip of the Triangle",
                Description: "Access to Tip of the Triangle provides benefits that allow you to interact with other top level producers with FIG.",
                Active: true,
                ShowIfAll: "TipOfTheTriangle:View|TipOfTheTriangle:Access"
            },
            {
                ID: "talentSolutionsTile",
                SREF: "Home.Resources.TalentSolutions",
                Title: "FIG Talent Solutions",
                LogoIMG: "talent-solutions-logo.svg",
                SubTitle: "Improve your skills",
                Description: "Ensuring the Right Fit for your Needs.",
                Active: true,
                ShowIfAll: "FigTalentSolutions:View"
            },
            {
                ID: "pozTile",
                SREF: "Home.Resources.PowerOfZero",
                Title: "Power of Zero",
                LogoIMG: "poz-logo.png",
                SubTitle: "Power of Zero",
                Description: "Join the Power of Zero Marketing Revolution.  Never worry about prospecting again.",
                Active: true,
                ShowIfAll: "PowerOfZeroPlus:View"
            },
            {
                ID: "millenniumTile",
                SREF: "Home.Resources.Millennium",
                Title: "Millennium",
                LogoIMG: "millenium-logo.svg",
                SubTitle: "Millennium",
                Description: "Get Started Building Business Retirement Plan Reviews.",
                Active: true,
                ShowIfAll: "Millennium:View"
            },
            {
                ID: "prepareTile",
                SREF: "Home.Resources.Prepare",
                Title: "Prepare",
                LogoIMG: "prepare-logo.png",
                SubTitle: "Prepare",
                Description: "Providing accurate, unbiased, and up-to-date retirement education through college-style courses and classes nationwide.",
                Active: false,
                ShowIfAll: "Prepare:View"
            },
            {
                ID: "megTile",
                SREF: "Home.Resources.MEG",
                Title: "Mark Edward Gaffney",
                LogoIMG: "meg-logo.png",
                SubTitle: "Mark Edward Gaffney",
                Description: "Boutique Marketing for Financial Advisors",
                Active: false,
                ShowIfAll: "MarkGaffney:View"
            },
            {
                ID: "loneBeaconTile",
                SREF: "Home.Resources.LoneBeacon",
                Title: "LoneBeacon",
                LogoIMG: "LoneBeacon-logo.png",
                SubTitle: "LoneBeacon",
                Description: "A Full-Service Sales & Marketing Company for Financial Advisors",
                Active: true,
                ShowIfAll: "LoneBeacon:View"
            },
            {
                ID: "locktonTile",
                SREF: "Home.Resources.Lockton",
                Title: "Lockton",
                LogoIMG: "lockton-logo.png",
                SubTitle: "Lockton",
                Description: "E&O Coverage - Lockton Affinity",
                Active: true,
                ShowIfAll: "Lockton:View"
            },
            {
                ID: "Hegna",
                SREF: "Home.Resources.Hegna",
                Title: "Retire Happy Now",
                LogoIMG: "rhn-logo.png",
                SubTitle: "",
                Description: "Your exclusive access to THE Retirement Income Expert, Tom Hegna!",
                Active: true,
                ShowIfAll: "HegnaRHN:View"
            },
            {
                ID: "bestInterestRulesTile",
                SREF: "Home.Resources.BestInterestRules",
                Title: "Best Interest Rules",
                LogoIMG: "best-interest-rules-logo-dark.png",
                SubTitle: "",
                Description: "Enhancements to NAIC best interest standard of conduct rules",
                Active: true,
                ShowIfAll: "MenuResources:View"
            },
            {
                ID: "dolTile",
                SREF: "Home.Resources.DOL",
                Title: "Industry Regulations & Updates",
                LogoIMG: "industry-regs-logo-d.png",
                SubTitle: "Continued learning on the DOL rule",
                Description: "Is your mind spinning with all things regulatory? Let FIG help you navigate your business through changes.",
                Active: true,
                ShowIfAll: "Dol:View"
            },
            {
                ID: "ssrTile",
                SREF: "Home.Resources.SSR",
                Title: "Social Security Resources",
                LogoIMG: "ssr-logo.svg",
                SubTitle: "Social Security Resources",
                Description: "Gain the knowledge to educate your potential clients on the future of Social Security.",
                Active: true,
                ShowIfAll: "SocialSecurityResources:View"
            },
            {
                ID: "carTile",
                SREF: "Home.Resources.CAR",
                Title: "CAR Program",
                LogoIMG: "car-logo.svg",
                SubTitle: "CAR Program",
                Description: "The CAR policy review can enhance the relationship with your client/prospect.",
                Active: true,
                ShowIfAll: "Car:View"
            },
            {
                ID: "salesCoachWOOTile",
                SREF: "Home.Resources.SalesCoachWOO",
                Title: "Sales Coach: Windows of Opportunity",
                LogoIMG: "salescoach-woo-logo-d.svg",
                SubTitle: "Improve your skills",
                Description: "Open the possibilities for your marketing strategies and systems.",
                Active: true,
                ShowIfAll: "SalesCoachWindowsOfOpportunity:View"
            },
            {
                ID: "ltcTrainingTile",
                SREF: "Home.Resources.LTCTraining",
                Title: "Care Planning Resources",
                LogoIMG: "care-planning-resources-logo.svg",
                SubTitle: "Care Planning",
                Description: "Video seminars and presentations to expand your knowledge.",
                Active: true,
                ShowIfAll: "LtcTraining:View"
            },
            {
                ID: "iulTile",
                SREF: "Home.Resources.IUL",
                Title: "IUL Complete",
                LogoIMG: "iul-logo.svg",
                SubTitle: "IUL Complete",
                Description: "Leverage one of the market’s important Life Insurance products with the complete turn-key IUL Solutions Program.",
                Active: true,
                ShowIfAll: "IulComplete:View"
            },
            {
                ID: "greenbrierTile",
                SREF: "Home.Resources.Greenbrier",
                Title: "Greenbrier",
                LogoIMG: "greenbrier-logo.png",
                SubTitle: " ",
                Description: "Join FIG’s exclusive escape to the Greenbrier resort!",
                Active: false,
                ShowIfAll: "Greenbrier:View"
            },
            {
                ID: "puntaMitaTile",
                SREF: "Home.Resources.PuntaMita",
                Title: "PuntaMita",
                LogoIMG: "punta-mita-logo.png",
                SubTitle: "Advisor Sales Contest – Inviting all FIG Advisors to Participate",
                Description: "Schechter Wealth wants to send you on an all-expense paid trip to Mexico!!",
                Active: true,
                ShowIfAll: "PuntaMita:View"
            },
            {
                ID: "tacTile",
                SREF: "Home.Resources.TheAmericanCollege",
                Title: "The American College",
                LogoIMG: "american-college-logo.png",
                SubTitle: "",
                Description: "Practical professional education, delivered by the nation’s only accredited nonprofit dedicated to the financial services profession.",
                Active: true,
                ShowIfAll: "AmericanCollege:View"
            },
            {
                ID: "officeDepotTile",
                SREF: "Home.Resources.OfficeDepot",
                Title: "Office Depot",
                LogoIMG: "od-omax-logo.svg",
                SubTitle: "",
                Description: "Log into our instance of Office Depot's website to take full advantage of all the great savings at Office Depot!",
                Active: true,
                ShowIfAll: "OfficeDepot:View"
            },
            {
                ID: "trainingTile",
                SREF: "Home.Resources.FIGTraining",
                Title: "FIG Carrier Specific & State Annuity Training",
                LogoIMG: "training-logo-sm.png",
                SubTitle: "",
                Description: "View requirements regarding carrier specific and state annuity training.",
                Active: true,
                ShowIfAll: "FigTraining:View"
            },
            {
                ID: "fusionNetix",
                SREF: "Home.Resources.FusionNetix",
                Title: "FusionNetix",
                LogoIMG: "FusionNetix-black-trans.png",
                Subtitle: "",
                Description: "The confidence your business needs to operate digitally, effectively, and safely.",
                Active: true,
                ShowIfAll: "MenuResources:View"
            },
            {
                ID: "fusionFinancialPartners",
                SREF: "Home.Resources.FusionFinancialPartners",
                Title: "Fusion Financial Partners",
                LogoIMG: "fusion-financial-part-black-trans.png",
                Subtitle: "",
                Description: "The strategy your business desires, to grow revenue, relationships and ideas.",
                Active: true,
                ShowIfAll: "MenuResources:View"
            }
        ];

        $ctrl.DashboardTiles = _.filter($ctrl.DashboardTiles,
            function (row) {
                var show = false;
                if (row.ShowIfAll)
                    show = permissionService.hasAllPermissions(row.ShowIfAll);
                if (row.HideIfOne)
                    if (permissionService.hasOnePermission(row.HideIfOne, true))
                        show = false;
                return show;
            });

    }

})(window.app, window.angular); // jshint ignore:line